import toast from "react-hot-toast";
import { downloadBillApi, exportExcelApi } from "services/dashboard";
import { downloadFile } from "utils/commonFun";
import { failMessage } from "utils/toastMessage";

export const downloadBill = async (selectedSite = {}, setLoading = () => { }, month, year) => {
    if (selectedSite?._id) {
        try {
            setLoading(true)
            const res = await downloadBillApi({
                plantId: selectedSite?._id,
                month,
                year,

            });
            console.log('res', res)
            if (res?.status === 200) {
                downloadFile(res?.data?.url)
            } else {
                failMessage(res?.message)
            }
        } catch (e) {
            console.log('error', e?.message)
        } finally {
            setLoading(false)
        }
    }
}